import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../types/app.types';
import {PaymentSummary} from '@wix/auto_sdk_ecom_cart-v-2';

export class PaymentSummaryModel {
  public payNow: PriceModel;
  public payLater: PriceModel;
  public payAfterFreeTrial: PriceModel;

  constructor(params: PaymentSummaryModel) {
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.payAfterFreeTrial = params.payAfterFreeTrial;
  }

  public static fromCartV1({
    payNow,
    payLater,
    payAfterFreeTrial,
  }: {
    payNow: PriceModel;
    payLater: PriceModel;
    payAfterFreeTrial: PriceModel;
  }): PaymentSummaryModel {
    return new PaymentSummaryModel({
      payNow,
      payLater,
      payAfterFreeTrial,
    });
  }

  public static fromCartV2(paymentSummary: PaymentSummary, modelContext: ModelContext): PaymentSummaryModel {
    return new PaymentSummaryModel({
      payNow: PriceModel.fromCartV2(paymentSummary.payNow, modelContext),
      payLater: PriceModel.fromCartV2(paymentSummary.payLater, modelContext),
      payAfterFreeTrial: PriceModel.fromCartV2(paymentSummary.payAfterFreeTrial, modelContext),
    });
  }
}
